import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'
import Image from 'next/image'

import { Column, Rows } from '@/components/layout'
import { Link } from '@/components/common'

import styles from './BlogArticleListing.module.scss'

const BlogArticleListing = ({ title, link, img, imgAlt, date, categories = {} }) => (
  <Column center className={cx('shadow-card', styles.wrapper)}>
    <Rows gap={0}>
      <div className={styles.imgWrapper}>
        <Image
          alt={imgAlt}
          height={0}
          sizes="100vw"
          src={img}
          style={{ width: '100%', height: 'auto' }}
          width={0}
        />
      </div>
      <Rows className={styles.content}>
        <Link className={styles.name} to={link}>{title}</Link>
        <p className={styles.details}>{date} |&nbsp;
          {categories.map((category, index) => (
            <Fragment key={category.slug}>
              <Link to={category.link}>{category.name}</Link>
              {index < categories.length - 1 && ', '}
            </Fragment>
          ))}
        </p>
      </Rows>
    </Rows>
  </Column>
)

BlogArticleListing.propTypes = {
  title: PropTypes.string,
  link: PropTypes.string,
  img: PropTypes.string,
  imgAlt: PropTypes.string,
  date: PropTypes.string,
  categories: PropTypes.arrayOf(PropTypes.shape({})),
}

export default BlogArticleListing
